<ng-container *ngIf="banks">

    <div class="row no-gutters" *ngIf="multi">
        <div class="col-sm-10 col-md-11 text-right"
             style="padding-right: 14px;">
            <a id="{{idPrefix}}btn.add_bank"
               mat-stroked-button
               color="accent"
               class="add-btn"
               (click)="addBank()">
                {{ 'office_management.btn.add_bank' | translate }}
            </a>
        </div>
    </div>

    <div class="row no-gutters">
        <div class="{{bankCol}} bank-column"
             *ngFor="let bank of banks; let idx = index">

            <div class="row no-gutters">

                <div class="col-sm-10">
                    <mat-card>

                        <div class="bank-title smp-title-thin-border full-width mb-3">
                            {{ bank.name ? bank.name : 'office_management.title.bank' | translate }}
                            <button id="{{idPrefix}}bank_{{idx}}.btn.remove"
                                    mat-icon-button
                                    class="delete-btn"
                                    (click)="removeBank(idx)"
                                    [disabled]="disabled">
                                <mat-icon class="dr-material-icon"
                                          [ngClass]="{ 'disabled': disabled }"
                                          matTooltip="{{ 'common.label.delete' | translate }}">clear
                                </mat-icon>
                            </button>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-sm-10">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ bank.trans.name | translate }}</mat-label>
                                    <input id="{{idPrefix}}bank_{{idx}}.{{bank.trans.name}}"
                                           type="text" matInput
                                           [(ngModel)]="bank.name"
                                           (blur)="onChange()"
                                           [disabled]="disabled">
                                </mat-form-field>
                            </div>

                            <div class="col-sm-2"></div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-sm-10">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ bank.trans.iban | translate }}</mat-label>
                                    <input id="{{idPrefix}}bank_{{idx}}.{{bank.trans.iban}}"
                                           type="text" matInput
                                           [(ngModel)]="bank.iban"
                                           (blur)="onChange()"
                                           [disabled]="disabled">
                                </mat-form-field>
                            </div>

                            <div class="col-sm-2"></div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-sm-10">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ bank.trans.bic | translate }}</mat-label>
                                    <input id="{{idPrefix}}bank_{{idx}}.{{bank.trans.bic}}"
                                           type="text" matInput
                                           [(ngModel)]="bank.bic"
                                           (blur)="onChange()"
                                           [disabled]="disabled">
                                </mat-form-field>
                            </div>

                            <div class="col-sm-2"></div>
                        </div>

                    </mat-card>
                </div>

                <div class="col-sm-2"></div>

            </div>

        </div>
    </div>

</ng-container>
